import React from 'react';
import { Box, Button, Checkbox, Dialog, Flex, Heading, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { CheckIcon, NotInterestedIcon } from 'shared/icons';
import { blockReasons, warningReasons } from 'Components/adminpanel/Resumes/settings';

const blockReasonOptions = blockReasons as string[];
const warningReasonOptions = warningReasons as string[];

const BLOCK_TITLE = '\u0411\u043b\u043e\u043a\u0443\u0432\u0430\u0442\u0438 \u0447\u0435\u0440\u0435\u0437:';
const WARNING_TITLE = '\u041f\u043e\u043f\u0435\u0440\u0435\u0434\u0438\u0442\u0438 \u043f\u0440\u043e:';
const ACTIVATE_LABEL = '\u0410\u043a\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438';
const BLOCK_LABEL = '\u0411\u043b\u043e\u043a\u0443\u0432\u0430\u0442\u0438';

const ResumeStatusDialogView = ({
   loading = false,
   onActivate,
   onDeactivate,
}: {
   loading?: boolean;
   onActivate: () => void;
   onDeactivate: () => void;
}) => {
   const [selectedBlockReasons, setSelectedBlockReasons] = React.useState<string[]>([]);
   const [selectedWarningReasons, setSelectedWarningReasons] = React.useState<string[]>([]);

   const toggleReason = (reason: string, type: 'block' | 'warning') => {
      const selectedReasons = type === 'block' ? selectedBlockReasons : selectedWarningReasons;
      const setSelectedReasons =
         type === 'block' ? setSelectedBlockReasons : setSelectedWarningReasons;

      if (selectedReasons.includes(reason)) {
         setSelectedReasons(selectedReasons.filter((item) => item !== reason));
      } else {
         setSelectedReasons([...selectedReasons, reason]);
      }
   };

   const isBlockButtonActive =
      selectedBlockReasons.length > 0 || selectedWarningReasons.length > 0;
   const isPublishButtonActive =
      selectedBlockReasons.length === 0 && selectedWarningReasons.length === 0;

   return (
      <Box className="resume-status-dialog">
         <Dialog.Title aria-describedby={undefined}>Moderate Resume</Dialog.Title>

         <Flex direction="column" gap="4" mt="4">
            <Flex direction="column" gap="3">
               <Heading as="h3" size="3" weight="medium">
                  {BLOCK_TITLE}
               </Heading>

               <Flex direction="column" gap="2">
                  {blockReasonOptions.map((reason) => (
                     <label className="resume-status-dialog__reason" key={reason}>
                        <Checkbox
                           checked={selectedBlockReasons.includes(reason)}
                           onCheckedChange={() => toggleReason(reason, 'block')}
                        />
                        <Text size="2">{reason}</Text>
                     </label>
                  ))}
               </Flex>
            </Flex>

            <Flex direction="column" gap="3">
               <Heading as="h3" size="3" weight="medium">
                  {WARNING_TITLE}
               </Heading>

               <Flex direction="column" gap="2">
                  {warningReasonOptions.map((reason) => (
                     <label className="resume-status-dialog__reason" key={reason}>
                        <Checkbox
                           checked={selectedWarningReasons.includes(reason)}
                           onCheckedChange={() => toggleReason(reason, 'warning')}
                        />
                        <Text size="2">{reason}</Text>
                     </label>
                  ))}
               </Flex>
            </Flex>
         </Flex>

         <Flex className="resume-status-dialog__actions" justify="start" gap="3" mt="5">
            <Button
               color="green"
               size="3"
               loading={loading}
               disabled={!isPublishButtonActive}
               onClick={onActivate}
            >
               <CheckIcon width={18} height={18} />
               {ACTIVATE_LABEL}
            </Button>

            <Button
               color="red"
               size="3"
               loading={loading}
               disabled={!isBlockButtonActive}
               onClick={onDeactivate}
            >
               <NotInterestedIcon width={18} height={18} />
               {BLOCK_LABEL}
            </Button>

            <Dialog.Close>
               <Button color="gray" size="3">
                  Cancel
               </Button>
            </Dialog.Close>
         </Flex>
      </Box>
   );
};

export const ResumeStatusDialog = observer(ResumeStatusDialogView);
